import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';

import { hostsApi } from '../../api/lib/hosts';

import { destinationGroupsKeys } from '@/features/destination-groups/api/query-keys/destination-groups';
import { destinationsKeys } from '@/features/destinations/api/query-keys/destinations';
import { hostsKeys } from '@/features/hosts/api/query-keys/hosts';

export const useUpdateHostDestinations = (onSuccess?: () => void) => {
  const { t } = useTranslation(['host']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ hostId, destinationsIds }: { hostId: number; destinationsIds: number[] }) =>
      hostsApi.updateHostDestinations(hostId, destinationsIds),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: hostsKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: destinationGroupsKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: destinationsKeys.all,
      });
      toast.success(t('host:successUpdateDestination'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
